//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.RoutingApplicationView.js";
let d=[[],[[[],"GetIsInitialized",{R_:{is_initialized:''}},0,0],[["num_run_type_displays"],"GetRunTypeNames",{R_:{run_type_name:""}},0,0],[["num_run_type_displays"],"GetLineFontIndices",{R_:{line_font_indices:""}},0,0],[["num_run_type_displays"],"GetLineFonts",{R_:{line_fonts:""}},0,0],[["num_run_type_displays"],"GetLineWidths",{R_:{line_widths:""}},0,0],[["num_run_type_displays"],"GetLineColorTypes",{R_:{line_color_types:""}},0,0],[["num_run_type_displays"],"GetLineColors",{R_:{line_colors:""}},0,0]],[]];
SPLM.Preferences.RoutingMechanical = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingMechanical";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RoutingMechanical.LineColorType = Object.freeze({
    "Unknown" : "Unknown", "Name" : "Name", "Index" : "Index", "Rgb" : "Rgb", "Hex" : "Hex", "Max" : "Max"});

export default SPLM;